var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 249,
    viewBox: "0 0 240 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25924_51460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.73 1V38.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33 19.6001H196.13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.62 195.27V212.66",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32 203.96H66.92",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.76 52.05V89.5801",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.53 70.8101H4",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.49 111.38C182.93 106.25 199.66 86.1599 199.66 62.1599C199.66 34.2799 177.06 11.6699 149.17 11.6699C121.28 11.6699 98.68 34.2799 98.68 62.1599C98.68 65.0499 98.92 67.8899 99.4 70.6499",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5 48.78C163.5 33.3 131.97 33.26 131.97 48.78C131.97 64.3 166.36 58.97 166.36 75.21C166.36 91.45 131.97 90.96 131.97 75.21",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17 27.23V37.15",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17 87.1899V97.1099",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 92.98C203.62 95.39 206.06 103.48 201.89 109.15L188.3 127.6",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49 54.1702C78.12 58.7802 85.25 67.2102 97.36 77.0602C113.3 90.0302 137.85 105.44 158.45 117.78C170.13 124.78 180.54 130.8 187.4 134.81C192 137.52 193.32 143.56 190.28 147.94L179.59 163.28",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14 176.17L128.78 219.82C132.93 222.85 138.75 221.88 141.69 217.66L145.18 212.65",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 45.7301C87.29 41.6101 76.87 44.5301 71.58 52.6001L31.47 113.8C26.82 120.89 25.6 129.26 27.43 136.94",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.03 172.77L143.22 146.29C132.61 139.05 118.15 141.76 110.88 152.34C103.6 162.94 106.29 177.44 116.89 184.73L155.38 211.2C164.64 217.57 177.31 215.26 183.73 206.04L199.3 183.69C202.44 179.18 203.01 173.36 200.8 168.33L193.87 157.32",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88 178.71C139.27 178.71 144.45 173.53 144.45 167.14C144.45 160.75 139.27 155.57 132.88 155.57C126.49 155.57 121.31 160.75 121.31 167.14C121.31 173.53 126.49 178.71 132.88 178.71Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.44 195.27C51.2471 195.27 62.44 184.077 62.44 170.27C62.44 156.463 51.2471 145.27 37.44 145.27C23.6329 145.27 12.44 156.463 12.44 170.27C12.44 184.077 23.6329 195.27 37.44 195.27Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76 245.67C137.49 243.46 152.04 239.45 167.1 233.73C209.6 217.59 240.05 193.94 235.1 180.91C233.28 176.11 226.91 173.42 217.48 172.74",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13 215.09C84.65 224.29 78.79 233.06 81.18 239.35C82.82 243.66 88.11 246.27 96 247.25",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25924_51460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233.63,
    height: 248.25,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2ed894f6990eaea4bc51207d15da4538.svg";
export { ForwardRef as ReactComponent };